module.exports = __webpack_public_path__ + "static/media/Fabrication Review.9d6fde2a.png";